import {
  Modal,
  Button,
  StackLayout,
  HeadingText,
  ParagraphText,
  ImageMessage,
} from "@leagueplatform/genesis-core";
import formChangesNotSavedInfo from "assets/form-changes-not-saved-info.svg";
import { useIntl } from "@leagueplatform/locales";
import { useIsBelowTablet } from "hooks/use-is-below-tablet.hook";
import { ModalActionButton } from "../common/modal-action-button.component";

type ExitWarningProps = {
  open?: boolean;
  stayButtonText?: string;
  onStay?: () => void;
  onProceed?: () => void;
};

export const ExitWarning = ({
  open,
  stayButtonText,
  onStay,
  onProceed,
}: ExitWarningProps) => {
  const { formatMessage } = useIntl();
  const isBelowTablet = useIsBelowTablet();

  return (
    <Modal.Root open={open}>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        width={{
          "@initial": 636,
          "@mobile": "100%",
          "@mobileLandscape": "100%",
        }}
      >
        <StackLayout spacing="$none" horizontalAlignment="stretch">
          <StackLayout
            horizontalAlignment="end"
            css={{
              padding: "$half",
              height: "auto",
            }}
          >
            <Button
              priority="tertiary"
              icon="tinyClose"
              size="small"
              hideLabel
              quiet
              onClick={onStay}
            >
              {stayButtonText ||
                formatMessage({ id: "STR_EXIT_WARNING_STAY_ON_PAGE" })}
            </Button>
          </StackLayout>
          <StackLayout
            css={{
              padding: "$two",
              paddingBlockStart: "$none",
            }}
            horizontalAlignment="stretch"
            spacing="$one"
          >
            <ImageMessage
              image={formChangesNotSavedInfo}
              css={{
                textAlign: "left",
                "@mobile": { padding: "$half" },
              }}
            >
              <Modal.Title>
                <HeadingText level="3" size="xl" css={{ paddingBlock: "$one" }}>
                  {formatMessage({ id: "STR_EXIT_WARNING_HEADING" })}
                </HeadingText>
              </Modal.Title>
              <Modal.Description>
                <ParagraphText css={{ color: "$onSurfaceTextSubdued" }}>
                  {formatMessage({
                    id: "STR_EXIT_WARNING_BODY",
                  })}
                </ParagraphText>
              </Modal.Description>
            </ImageMessage>

            <StackLayout
              horizontalAlignment={{
                "@initial": "start",
                "@mobile": "center",
              }}
              orientation={{
                "@initial": "horizontal",
                "@mobile": "vertical",
              }}
              spacing="$one"
              css={{
                flexGrow: 0,
                "@mobile": {
                  flexFlow: "column",
                },
              }}
            >
              <ModalActionButton
                actionType="submit"
                onClick={onStay}
                width={isBelowTablet ? "fillContainer" : "hugContents"}
                buttonText={formatMessage({
                  id: "STR_EXIT_WARNING_STAY_ON_PAGE",
                })}
                size="large"
                priority="primary"
              />
              <ModalActionButton
                actionType="cancel"
                onClick={onProceed}
                width={isBelowTablet ? "fillContainer" : "hugContents"}
                buttonText={formatMessage({
                  id: "STR_EXIT_WARNING_LEAVE_PAGE",
                })}
                size="large"
                priority="secondary"
              />
            </StackLayout>
          </StackLayout>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
};
